import { render, staticRenderFns } from "./role-picker.vue?vue&type=template&id=439ee9c9&scoped=true&"
import script from "./role-picker.ts?vue&type=script&lang=ts&"
export * from "./role-picker.ts?vue&type=script&lang=ts&"
import style0 from "./role-picker.vue?vue&type=style&index=0&id=439ee9c9&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "439ee9c9",
  null
  
)

export default component.exports